import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import { IContextRowActionsProps } from './context-selector.types';

// Edit-mode row actions: keep the edits (lock the row) or discard them (revert
// to the last-approved selection, or drop a never-approved row).
export const ContextRowActions: React.FC<IContextRowActionsProps> = ({ onApprove, onCancel }) => (
  <>
    <IconButton size="small" aria-label="Keep changes" onClick={onApprove}>
      <CheckIcon fontSize="small" />
    </IconButton>
    <IconButton size="small" aria-label="Cancel changes" onClick={onCancel}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </>
);
